import React from 'react';
import { Minus, Plus } from 'lucide-react';
import { Slider } from '../ui/slider';

export const LevelControl = ({ id, label, color, price, digits, pips, min, max, onPips, onNudge, hint }) => (
  <div className="sim-level" style={{ '--lvl': color }} data-testid={`level-${id}`}>
    <div className="flex items-center justify-between gap-2">
      <div className="flex items-center gap-2">
        <span className="h-2.5 w-2.5 rounded-full" style={{ background: color }} />
        <span className="text-xs font-semibold uppercase tracking-[0.14em] text-slate-400">{label}</span>
      </div>
      <div className="flex items-center gap-1.5">
        <button type="button" className="sim-nudge" onClick={() => onNudge(-1)} data-testid={`level-${id}-minus`} aria-label={`${label} down`}><Minus size={13} /></button>
        <span className="sim-mono min-w-[84px] text-center text-base font-semibold text-white" data-testid={`level-${id}-price`}>
          {price ? price.toFixed(digits) : '—'}
        </span>
        <button type="button" className="sim-nudge" onClick={() => onNudge(1)} data-testid={`level-${id}-plus`} aria-label={`${label} up`}><Plus size={13} /></button>
      </div>
    </div>
    <Slider
      className="sim-slider mt-3"
      value={[Math.min(max, Math.max(min, pips || min))]}
      min={min}
      max={max}
      step={0.5}
      onValueChange={([v]) => onPips(v)}
      data-testid={`level-${id}-slider`}
    />
    <div className="mt-1.5 flex justify-between text-[11px] text-slate-500">
      <span>{hint}</span>
      <span className="sim-mono" data-testid={`level-${id}-pips`}>{(pips || 0).toFixed(1)} pips</span>
    </div>
  </div>
);
